import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  getInstructorData,
  getInstructorwithStudentData,
  getInstructorDataWithStatus,
  getInstructorwithStudentDataWithStatus,
} from "../../../../lib/taskmanageview";
import { getInstructorStudent } from "../../../../lib/instructorstudentview";
import { updateData, deleteIdData } from "../../../../lib/taskm";
import { useAuth } from "../../../../usercontext";
import TaskEdit from "../../../ui/taskedit";

export default function Tasks({ slug }) {
  const [tasklist, setTaskList] = useState([]);
  const { profile, setProfile } = useAuth();
  const [newAnswer, setNewAnswer] = useState();
  const [updated, setUpdated] = useState(false);
  const [updatedId, setUpdatedId] = useState(0);  
  const [selectedStudent, setSelectedStudent] = useState("All");
  const [instructorStudent, setInstructorStudent] = useState([]);
  const [collapseOpenClose, setCollapseOpenClose] = useState(false);
  // 1 : All , 2 : Open ,  4 : Close
  const [tab, setTab] = useState(2);

  const [tabCurrent, setTabCurrent] = useState(0);

  const handleDelete = async (id) => {
    const choice = window.confirm("Are You Sure?");
    if (choice) {
      await deleteIdData(id);
      GetStudentData();
    }
  };

  const collapseAll = () => {
    setCollapseOpenClose(!collapseOpenClose);
  };

  async function GetStudentData() {
    let tasks;
    setTaskList([]);
    if (tab === 1) {
      //All
      tasks = await getInstructorwithStudentData(profile.id, slug);
      setTabCurrent(0);
    }

    if (tab === 2)
      //"Current"
      tasks = await getInstructorwithStudentDataWithStatus(
        profile.id,
        slug,
        "Current"
      );

    if (tab === 3)
      //"Later"
      tasks = await getInstructorwithStudentDataWithStatus(
        profile.id,
        slug,
        "Later"
      );

    if (tab === 4)
      //Closed
      tasks = await getInstructorwithStudentDataWithStatus(
        profile.id,
        slug,
        "Closed"
      );

    setTaskList(tasks);
    console.log("tasks",tasks);
  }

  useEffect(() => {
    console.log("new anwser", newAnswer);
    //GetStudentData();

    let updatedTask = {desc :newAnswer };

    let revTasklist = tasklist.map(task =>
        task.id === updatedId ? { ...task, ...updatedTask } : task
      )

      console.log("revTasklist",revTasklist);
      
    
  }, [updated]);

  async function GetInstructorStudentData() {
    const students = await getInstructorStudent(profile.id);
    setInstructorStudent(students);
  }
  useEffect(() => {
    GetStudentData();
 
  }, [tab]);

  useEffect(() => {
    GetStudentData();
    setTab(2);
  }, []);

  async function ChangeTaskStatus(Id, statusway) {
    //console.log("status",Id, status);

    await updateData({
      id: Id,
      statusway: statusway,
    });

    GetStudentData();
  }

  const toggleTab = (id) => {
    setTab(id);
  };

  const essentialheader = (name, buttonname, buttonlink) => {
		const toggleButton = (
			<button
				type="button"
				className="btn btn-outline-info mx-2"
				data-bs-toggle="collapse"
				data-bs-target="#collapseAgenda"
				aria-expanded="true"
				aria-controls="collapseAgenda"
			>
				<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" className="bi bi-chevron-double-down" viewBox="0 0 16 16">
					<path
						fillRule="evenodd"
						d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
					/>
					<path
						fillRule="evenodd"
						d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
					/>
				</svg>
			</button>
		)

		return (
			<div className="d-flex pb-1 justify-content-between align-items-center">
				<div>
					<h4>
						{name}
						{name === 'Agenda' && toggleButton}
					</h4>
				</div>
				<div className="d-flex">
					<div className="ticket-btn-grp">
						<Link to={buttonlink}>{buttonname}</Link>
					</div>
				</div>
			</div>
		)
	}
	return (
		<div className="settings-widget">
			<div className="settings-inner-blk p-0">
				<div className="comman-space pb-0">
					{essentialheader('Agenda', 'Add Item to Student', `/instructor/instructor-taskmanage-edit/${slug}/Student`)}
					<div className="p2 collapse" id="collapseAgenda">
						{/* Ticket Tab */}
						<div className="category-tab tickets-tab-blk">
							<div className="mb-2 d-flex  h-100">
								<div className="flex-fill">
									<ul className="nav nav-justified">
										<li className="nav-item" style={{ flexBasis: 'auto' }}>
											<Link
												//to="#all"
												className={tab === 1 ? 'nav-link active' : 'nav-link'}
												//data-bs-toggle="tab"
												onClick={(e) => {
													e.preventDefault()
													toggleTab(1)
												}}
											>
												All
											</Link>
										</li>
										<li className="nav-item" style={{ flexBasis: 'auto' }}>
											<Link
												//to="#open"
												className={tab === 2 ? 'nav-link active' : 'nav-link'}
												//data-bs-toggle="tab"
												onClick={(e) => {
													e.preventDefault()
													toggleTab(2)
												}}
											>
												Agenda-1
											</Link>
										</li>
										<li className="nav-item" style={{ flexBasis: 'auto' }}>
											<Link
												//to="#open"
												className={tab === 3 ? 'nav-link active' : 'nav-link'}
												//data-bs-toggle="tab"
												onClick={(e) => {
													e.preventDefault()
													toggleTab(3)
												}}
											>
												Agenda-2
											</Link>
										</li>
										<li className="nav-item" style={{ flexBasis: 'auto' }}>
											<Link
												//to="#close"
												className={tab === 4 ? 'nav-link active' : 'nav-link'}
												//data-bs-toggle="tab"
												onClick={(e) => {
													e.preventDefault()
													toggleTab(4)
												}}
											>
												Closed
											</Link>
										</li>
									</ul>
								</div>
								<div className="text-center">
									<button
										className="btn btn-outline-info"
										data-bs-toggle="collapse"
										role="button"
										aria-expanded="false"
										onClick={() => collapseAll()}
									>
										<svg
											xmlns="http://www.w3.org/2000/svg"
											width="18"
											height="18"
											fill="currentColor"
											className="bi bi-chevron-double-down"
											viewBox="0 0 16 16"
										>
											<path
												fillRule="evenodd"
												d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
											/>
											<path
												fillRule="evenodd"
												d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
											/>
										</svg>{' '}
										Collapse All
									</button>
								</div>
							</div>
						</div>
						{/* Ticket Tab */}

						{/* Referred Ticket List */}
						<div className="tab-content">
							<div className="settings-tickets-blk table-responsive">
								{/* Referred Users */}
								<div className="table-responsive">
									<div className="container-fluid">
										<div className="row w-95">
											<div className="col">
												<div className="row mb-2">
													<div className="col">
														<strong>Topic</strong>
													</div>
													<div className="col">
														<strong>Student</strong>
													</div>
													<div className="col">
														<strong>Date</strong>
													</div>
													<div className="col">
														<strong>Status</strong>
													</div>
													<div className="col">
														<strong>Detail</strong>
													</div>
													<div className="col">
														<strong>Process</strong>
													</div>
												</div>
												{tasklist.map(function (data, ix) {
													return (
														<div key={ix} className="row mb-2">
															<div className="col">{data.subject}</div>
															<div className="col">{data.studentinfo}</div>
															<div className="col">{data.setDate}</div>
															<div className="col">
																<div className="select-container">
																	<select value={data.statusway} onChange={(e) => ChangeTaskStatus(data.id, e.target.value)} className="select-box">
																		<option key={1} value="Current">
																			Agenda-1
																		</option>
																		<option key={2} value="Later">
																			Agenda-2
																		</option>
																		<option key={3} value="Closed">
																			Closed
																		</option>
																	</select>
																	<div className="icon-container">
																		<i className="fa-solid fa-chevron-down"></i>
																	</div>
																</div>
															</div>
															<div className="col">
																<a
																	className="btn btn-outline-info"
																	data-bs-toggle="collapse"
																	href={`#collapseExample${data.id}`}
																	role="button"
																	aria-expanded="false"
																	aria-controls={`collapseExample${data.id}`}
																>
																	<svg
																		xmlns="http://www.w3.org/2000/svg"
																		width="18"
																		height="18"
																		fill="currentColor"
																		className="bi bi-chevron-double-down"
																		viewBox="0 0 16 16"
																	>
																		<path
																			fillRule="evenodd"
																			d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
																		/>
																		<path
																			fillRule="evenodd"
																			d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
																		/>
																	</svg>
																</a>
															</div>
															<div className="col">
																<div className="profile-share">
																	<button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
																		Delete
																	</button>
																</div>
															</div>
															<div className={`collapse ${collapseOpenClose ? 'show' : ''}`} id={`collapseExample${data.id}`}>
																<div className="row">
																	<div className="col" colSpan={6}>
																		<TaskEdit
																			value={data.desc}
																			setValue={setNewAnswer}
																			id={data.id}
																			setStatus={setUpdated}
																			status={updated}
																			setUpdatedId={setUpdatedId}
																		/>
																	</div>
																</div>
															</div>
														</div>
													)
												})}
											</div>
										</div>
									</div>
								</div>
								{/* Referred Users */}
							</div>
						</div>
					</div>
					{/* Referred Ticket List */}
				</div>
			</div>
		</div>
	)
}
